!function() {
  'use strict';

  class StickyAtcForm extends HTMLElement {
    constructor() {
      super();
      this.boundHandleClick = this.handleClick.bind(this);
      this.boundCheckAlia = this.checkAlia.bind(this);
    }

    connectedCallback() {
      this.section = this.closest('product-info') || this.closest('[data-section-type="product-template"]');
      this.form = this.section?.querySelector('[data-product-form]');
      if (!this.section || !this.form) return;

      this.atcBtn = this.querySelector('[data-sticky-atc-btn]');
      this.btnText = this.querySelector('.sticky-atc__button-text');

      this.addEventListener('click', this.boundHandleClick);
      this.subVariant();
      this.watchAlia();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.boundHandleClick);
      this.unsub?.();
      this.aliaObserver?.disconnect();
      if (this.aliaInterval) clearInterval(this.aliaInterval);
    }

    handleClick(e) {
      if (e.target.closest('[data-sticky-atc-btn]')) {
        e.preventDefault();
        var addBtn = this.form.querySelector('[data-add-to-cart]');
        if (!addBtn || addBtn.hasAttribute('disabled')) return;
        if (this.form.requestSubmit) {
          this.form.requestSubmit(addBtn);
        } else {
          addBtn.click();
        }
      }
    }

    /* Show ATC button only when Alia teaser is NOT visible */
    watchAlia() {
      this.checkAlia();
      // Re-check whenever DOM changes (Alia teaser added/removed/hidden)
      this.aliaObserver = new MutationObserver(this.boundCheckAlia);
      this.aliaObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class', 'hidden']
      });
      // Polling fallback in case Alia uses shadow DOM mutations we can't observe
      this.aliaInterval = setInterval(this.boundCheckAlia, 1000);
    }

    checkAlia() {
      var aliaRoot = document.querySelector('[id^="alia-root"]');
      var aliaVisible = false;

      if (aliaRoot) {
        // Check if any visible Alia button/teaser exists
        var aliaBtn = aliaRoot.querySelector('.alia-style-button-primary, [class*="alia-style-button"]');
        if (aliaBtn) {
          var rect = aliaBtn.getBoundingClientRect();
          aliaVisible = rect.width > 0 && rect.height > 0 && aliaBtn.offsetParent !== null;
        } else {
          // Fallback: any visible Alia content
          var rootRect = aliaRoot.getBoundingClientRect();
          aliaVisible = rootRect.width > 0 && rootRect.height > 0;
        }
      }

      this.classList.toggle('is-visible', !aliaVisible);
    }

    subVariant() {
      if (window.subscribe && window.theme?.PUB_SUB_EVENTS?.variantChange) {
        this.unsub = window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function(msg) {
          var data = msg.data;
          var sectionId = data?.sectionId;
          if (!sectionId) return;
          var mySection = this.section;
          if (sectionId !== mySection?.dataset?.section && sectionId !== mySection?.dataset?.originalSection) return;
          this.updateBtn(data.variant);
        }.bind(this));
      }
    }

    updateBtn(variant) {
      if (!this.atcBtn || !variant) return;
      var available = variant.available;
      this.atcBtn.toggleAttribute('disabled', !available);
      if (this.btnText) {
        this.btnText.textContent = window.theme?.strings?.[available ? 'addToCart' : 'soldOut']
          || (available ? 'Add to cart' : 'Sold out');
      }
    }
  }

  if (!customElements.get('sticky-atc-form')) {
    customElements.define('sticky-atc-form', StickyAtcForm);
  }
}();
